import type {
  KalturaAggregationCountFilter,
  KalturaChannelFilter,
  KalturaFavoriteFilter,
  KalturaListGroupsRepresentativesFilter,
  KalturaSearchAssetFilter,
  KalturaPersonalListSearchFilter,
  KalturaBookmarkFilter,
  KalturaUserAssetRuleFilter,
  KalturaPersonalListFilter,
  KalturaAssetHistoryFilter,
  KalturaAssetHistorySuppressFilter,
  KalturaSeriesRecordingFilter,
  KalturaRecordingFilter,
  KalturaProductPriceFilter,
  KalturaPpvFilter,
  KalturaEntitlementFilter,
} from './filters';
import type {
  KalturaAssetMetaOrTagGroupBy,
  KalturaDetachedResponseProfile,
  KalturaDynamicOrderBy,
  KalturaFilterPager,
  KalturaOnDemandResponseProfile,
  KalturaStringValue,
  KalturaBookmark,
  KalturaBookmarkPlayerData,
} from './objects';

function createFactory<T extends { objectType?: unknown }>(objectType: T['objectType']) {
  return function createObject(args: Omit<T, 'objectType'>) {
    return {
      objectType,
      ...args,
    };
  };
}

// Objects

export const createAssetMetaOrTagGroupBy = createFactory<KalturaAssetMetaOrTagGroupBy>('KalturaAssetMetaOrTagGroupBy');
export const createDynamicOrderBy = createFactory<KalturaDynamicOrderBy>('KalturaDynamicOrderBy');
export const createDetachedResponseProfile = createFactory<KalturaDetachedResponseProfile>(
  'KalturaDetachedResponseProfile',
);
export const createOnDemandResponseProfile = createFactory<KalturaOnDemandResponseProfile>(
  'KalturaOnDemandResponseProfile',
);
export const createPager = createFactory<KalturaFilterPager>('KalturaFilterPager');

// Filters
export const createAggregationCountFilter = createFactory<KalturaAggregationCountFilter>(
  'KalturaAggregationCountFilter',
);
export const createBookmarkFilter = createFactory<KalturaBookmarkFilter>('KalturaBookmarkFilter');
export const createChannelFilter = createFactory<KalturaChannelFilter>('KalturaChannelFilter');
export const createEntitlementFilter = createFactory<KalturaEntitlementFilter>('KalturaEntitlementFilter');
export const createFavoriteFilter = createFactory<KalturaFavoriteFilter>('KalturaFavoriteFilter');
export const createListGroupsRepresentativesFilter = createFactory<KalturaListGroupsRepresentativesFilter>(
  'KalturaListGroupsRepresentativesFilter',
);
export const createSearchAssetFilter = createFactory<KalturaSearchAssetFilter>('KalturaSearchAssetFilter');
export const createPersonalListFilter = createFactory<KalturaPersonalListFilter>('KalturaPersonalListFilter');
export const createPersonalListSearchFilter = createFactory<KalturaPersonalListSearchFilter>(
  'KalturaPersonalListSearchFilter',
);
export const createProductPriceFilter = createFactory<KalturaProductPriceFilter>('KalturaProductPriceFilter');
export const createPpvFilter = createFactory<KalturaPpvFilter>('KalturaPpvFilter');
export const createUserAssetRuleFilter = createFactory<KalturaUserAssetRuleFilter>('KalturaUserAssetRuleFilter');
const createStringValue = createFactory<KalturaStringValue>('KalturaStringValue');

export function createKalturaStringValue(value: string) {
  return createStringValue({ value });
}

export const createBookmarkPayload = createFactory<Partial<KalturaBookmark>>('KalturaBookmark');
export const createBookmarkPlayerData = createFactory<KalturaBookmarkPlayerData>('KalturaBookmarkPlayerData');

export const createAssetHistoryFilter = createFactory<KalturaAssetHistoryFilter>('KalturaAssetHistoryFilter');

export const createAssetHistorySuppressFilter = createFactory<KalturaAssetHistorySuppressFilter>(
  'KalturaAssetHistorySuppressFilter',
);

export const createRecordingFilter = createFactory<KalturaRecordingFilter>('KalturaRecordingFilter');
export const createSeriesRecordingFilter = createFactory<KalturaSeriesRecordingFilter>('KalturaSeriesRecordingFilter');
